import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
@Component({
	selector: "app-radio-button-proposals",
	templateUrl: "./radio-button-proposals.component.html",
	styleUrls: ["./radio-button-proposals.component.css"]
})
export class RadioButtonProposals implements OnInit {
	radio = new UntypedFormControl("");
	@Output() valueRadio = new EventEmitter();
	@Input() disable = false;
	@Input() radioTextTitle = "";
	@Input() helpText = "";
	@Input() idButtonTrue = "";
	@Input() idButtonFalse = "";
	@Input() editarVisualizarProposta = false;

	constructor() {}

	ngOnInit(): void {
		if (this.editarVisualizarProposta) {
			this.radio = new UntypedFormControl("false");
			this.valueRadio.emit("false");
		}
	}

	radioSelected() {
		this.valueRadio.emit(this.radio.value);
	}
}
